<template>
  <draggable
    :list="nodosInstancia"
    animation="500"
    :class="[isChild ? 'm-edition-asset-contents-list-child' : '', 'm-edition-asset-contents-list']"
    :disabled="disabledDragg"
    fallback-class="display-none"
    :fallback-on-body="true"
    :force-fallback="true"
    ghost-class="m-edition-asset-contents-list-item-ghost"
    :group="{ name: 'm-edition-asset-contents-list', pull: true, put: false }"
    :invert-swap="true"
    :scroll="true"
    :scroll-sensitivity="50"
    tag="ul"
    @change="changeOrder"
  >
    <li
      v-for="nodo in nodosInstancia"
      :key="nodo.id"
      :class="[{ 'm-edition-asset-contents-list-item-drag': !disabledDragg }, 'm-edition-asset-contents-list-item']"
    >
      <div :class="!disabledSelected && nodo.id === $store.getters.getAssetSelectedNode.id
        ? 'm-edition-asset-contents-list-item-data m-edition-asset-contents-list-item-data-current'
        : 'm-edition-asset-contents-list-item-data'"
      >
        <a
          class="m-edition-asset-contents-list-item-data-name"
          href="#"
          @click.prevent="toggleChildren(nodo.id, nodo.children.length)"
        >
          <i
            :id="`node-icon-circle-${nodo.id}`"
            class="fas fa-spinner fa-spin node-icon-loading"
          >
          </i>
          <i
            :id="`node-icon-caret-${nodo.id}`"
            :class="[nodo.children.length ? 'fas fa-caret-down' : 'fas fa-caret-right', 'node-icon-caret']"
          >
          </i>
          <i
            :id="`node-icon-move-${nodo.id}`"
            class="far fa-arrows-alt node-icon-move"
          >
          </i>
          <span :class="nodeStateClass">
            {{ nodo.nombre }}
            <small v-if="nodo.children.length">
              ({{ nodo.children.length }} {{ $t('mEditionAssetContentsTreeNodes.subcontents') }})
            </small>
          </span>
        </a>
        <div :class="`m-edition-asset-contents-list-item-data-actions-${nodeActionsClass}`">
          <MoleculeEditionAssetContentsTreeNodeActions
            :is="moleculeNodeActions"
            :contenido="contenido"
            :element="element"
            :info="info"
            :level="level"
            :nodo="nodo"
            :parent="parent"
            @emitAction="emitAction"
          />
        </div>
      </div>
      <MoleculeEditionAssetContentsTreeNodeFixed
        v-if="nodo.children.length"
        :id="`child-${nodo.id}`"
        class="m-edition-asset-contents-list-child"
        :contenido="contenido"
        :disabledDragg="disabledDragg"
        :disabledSelected="disabledSelected"
        :element="element"
        :info="info"
        :is-child="true"
        :level="level + 1"
        :node-actions="nodeActions"
        :node-actions-class="nodeActionsClass"
        :nodos="nodo.children"
        :parent="nodo"
        @emitAction="emitAction"
      />
    </li>
  </draggable>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'MoleculeEditionAssetContentsTreeNodeFixed',

  components: {
    draggable
  },

  props: {
    contenido: Object,

    disabledDragg: {
      type: Boolean,
      default: true
    },

    disabledSelected: {
      type: Boolean,
      default: true
    },

    element: Object,

    info: {
      type: Object,
      default: () => ({})
    },

    isChild: Boolean,

    level: {
      type: Number,
      default: 0
    },

    nodeActions: String,
    nodeActionsClass: String,
    nodos: Array,

    parent: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      moleculeNodeActions: '',
      nodosInstancia: []
    }
  },

  computed: {
    // TODO: desarrollar esta propiedad computada al implementar este component
    // donde se utiliza MoleculeEditionAssetContentsTreeNode
    nodeStateClass () {
      return ''
    }
  },

  watch: {
    nodeActions: {

      handler () {
        this.moleculeNodeActions = () => import(`@/components/molecules/MoleculeEditionAssetContentsTreeNode${this.nodeActions}`)
      },

      immediate: true
    },

    nodos () {
      this.setNodosInstancia()
    }
  },

  created () {
    // this.showChildren = this.nodeActions === 'Questions'
    if (this.parent === null) {
      this.$store.commit('setAssetSelectedNode', this.nodos[0])
    }
    this.setNodosInstancia()
  },

  methods: {
    changeOrder (event) {
      if (event.added || event.moved || event.removed) {
        let parent = this.parent ? this.parent.id : null
        let params = { action: 'changeOrder', event: event, nodos: this.nodosInstancia, parent: parent }
        this.$emit('emitAction', params)
      }
    },

    emitAction (params) {
      // TODO: Implementar switch para llamar a otros métodos en emit
      if (params.action === 'changeOrder') {
        this.setChildren(params)
      }
    },

    setChildren (params) {
      let index = this.nodosInstancia.findIndex(nodo => nodo.id === params.parent)
      this.nodosInstancia[index].children = [...params.nodos]
      this.changeOrder(params.event)
    },

    setNodosInstancia (nodos) {
      this.nodosInstancia = [...this.nodos]
      this.nodosInstancia.forEach(nodo => {
        nodo = Object.assign({}, nodo)
        nodo.children = [...nodo.children]
      })
    },

    toggleChildren (id, length) {
      let display = document.getElementById(`child-${id}`).style.display === 'none'
        ? 'block'
        : 'none'
      document.getElementById(`node-icon-caret-${id}`).className = display === 'block' && length > 0
        ? 'fas fa-caret-down node-icon-caret'
        : 'fas fa-caret-right node-icon-caret'
      document.getElementById(`child-${id}`).style.display = display
    }
  }
}
</script>
